import { PageHeader } from '@ant-design/pro-layout';

export default function CustomPageHeader(props) {
  return <PageHeader {...props} />;
}
